module.exports = __webpack_public_path__ + "static/media/bigGreenTemplate.d05e2bb7.png";